interface BaseModel {
  createdAt: Date | string;
}

export const sortByCreatedAt = <T extends BaseModel>(
  arr: T[],
  onCollision?: (x: T, y: T) => number
) => {
  return arr.sort((a, b) => {
    const value =
      new Date(a.createdAt).valueOf() - new Date(b.createdAt).valueOf();

    if (value === 0) {
      return onCollision ? onCollision(a, b) : value;
    }

    return value;
  });
};
